import { memo } from "react";
import PropTypes from "prop-types";
import { OFFER_TYPES } from "app/constants";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import { FormattedMessage } from "react-intl";
import { Amount } from "app/components/ui/Amount/Amount";

const PriceChangedWarningMessage = ({
	newPrice,
	oldPrice,
	offerType,
	messageFlightAccommodationChangeUp = "error.payment.flight.price.changed.up.message",
	messageFlightAccommodationChangeDown = "error.payment.flight.price.changed.down.message",
	messageAccommodationOnlyChangeUp = "error.payment.price.changed.up.message",
	messageAccommodationOnlyChangeDown = "error.payment.price.changed.down.message",
	className,
}) => {
	const displayMessage = Boolean(newPrice) && Boolean(oldPrice);

	if (!displayMessage) {
		return false;
	}

	let priceChangeWarning = false;
	const priceChangedDelta = newPrice - oldPrice;

	if (priceChangedDelta > 0) {
		if (offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION) {
			priceChangeWarning = (
				<FormattedMessage
					id={messageFlightAccommodationChangeUp}
					tagName="span"
					values={{
						amount: <Amount value={Math.abs(priceChangedDelta)} />,
					}}
				/>
			);
		} else {
			priceChangeWarning = (
				<FormattedMessage
					id={messageAccommodationOnlyChangeUp}
					tagName="span"
					values={{
						amount: <Amount value={Math.abs(priceChangedDelta)} />,
					}}
				/>
			);
		}
	} else if (offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION) {
		priceChangeWarning = (
			<FormattedMessage
				id={messageFlightAccommodationChangeDown}
				tagName="span"
				values={{
					amount: <Amount value={Math.abs(priceChangedDelta)} />,
				}}
			/>
		);
	} else {
		priceChangeWarning = (
			<FormattedMessage
				id={messageAccommodationOnlyChangeDown}
				tagName="span"
				values={{
					amount: <Amount value={Math.abs(priceChangedDelta)} />,
				}}
			/>
		);
	}

	return <AlertMessage message={priceChangeWarning} className={className} />;
};

PriceChangedWarningMessage.propTypes = {
	offerType: PropTypes.string,
	oldPrice: PropTypes.number,
	newPrice: PropTypes.number,
	messageFlightAccommodationChangeUp: PropTypes.string,
	messageFlightAccommodationChangeDown: PropTypes.string,
	messageAccommodationOnlyChangeUp: PropTypes.string,
	messageAccommodationOnlyChangeDown: PropTypes.string,
	className: PropTypes.string,
};

export default memo(PriceChangedWarningMessage);
